import axiosClient from './client'

export const startRoundups = (userId, id) => (
  axiosClient().post(`/users/${userId}/campaigns/${id}/start_roundups`)
)

export const stopRoundups = (userId, id) => (
  axiosClient().delete(`/users/${userId}/campaigns/${id}/stop_roundups`)
)

export const startTithing = (userId, id) => (
  axiosClient().post(`/users/${userId}/campaigns/${id}/start_tithing`)
)

export const stopTithing = (userId, id) => (
  axiosClient().delete(`/users/${userId}/campaigns/${id}/stop_tithing`)
)
